import { HeadlineSize, HeadlineTag } from '../components/headline/constants/headline-types';

export function clampHeadlineSizeTo(allowedSizes: readonly HeadlineSize[], current: HeadlineSize): HeadlineSize {
  if (!current) return;
  return clampHeadlineSize(allowedSizes[0], allowedSizes.slice(-1)[0], current);
}

export function clampHeadlineSize(from: HeadlineSize, to: HeadlineSize, current: HeadlineSize): HeadlineSize {
  const regexStringPart = /\D+/;
  const regexNumberPart = /\d+/;

  const stringPart = current.match(regexStringPart)[0];
  const fromNumber: number = parseInt(from.match(regexNumberPart)[0]);
  const toNumber: number = parseInt(to.match(regexNumberPart)[0]);
  const currentNumber: number = parseInt(current.match(regexNumberPart)[0]);
  const clampedNumber: number = Math.max(fromNumber, Math.min(currentNumber, toNumber));

  return `${stringPart}${clampedNumber}` as HeadlineSize;
}

export function useTheRightHtmlTagForHeadline(headlineTag: HeadlineTag, defaultHeadlineTag: HeadlineTag) {
  return !!headlineTag ? headlineTag : defaultHeadlineTag;
}
